'use es6';

import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { getSharedTaskQueues, createGetSharedTaskQueues } from 'reference-resolvers/api/SharedTaskQueuesApi';
import { createGetTaskQueuesByIds, getTaskQueuesByIds } from 'reference-resolvers/api/TaskQueuesApi';
export const createSharedTaskQueuesReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.SHARED_TASK_QUEUES,
  createFetchByIds: createGetTaskQueuesByIds,
  createFetchSearchPage: createGetSharedTaskQueues,
  fetchSearchPage: getSharedTaskQueues,
  fetchByIds: getTaskQueuesByIds
}, options));
export default createSharedTaskQueuesReferenceResolver();